import { IReservation, ISegmentedOption, Label, ReservationStatus, Segmented, StringUtils } from '@localina/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReservationStatusIcon } from '.';

interface IProps {
    reservation: IReservation;
    disabled?: boolean;
    onChange?: (status: string) => void;
}

export const SelectReservationStatus: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const statusOptions: ISegmentedOption[] = [
        ReservationStatus.APPROVED,
        ReservationStatus.FULFILLED,
        ReservationStatus.NO_SHOW,
        ReservationStatus.RESTAURANT_CANCELLED,
    ].map((status) => ({
        label: (
            <div className="select-reservation-status__option">
                <ReservationStatusIcon status={status} />
                <Label type="info" value={t(`reservations.status.${status}`)} />
            </div>
        ),
        value: status,
    }));

    const handleChange = (value: string) => {
        if (props.onChange) {
            props.onChange(value);
        }
    };

    return (
        <div className={StringUtils.combineStrings(['select-reservation-status', props.disabled && 'disabled'])}>
            <Segmented
                value={props.reservation.status}
                options={statusOptions.map((option) => ({ ...option, disabled: props.disabled }))}
                onChange={handleChange}
            />
        </div>
    );
};
